import { cn } from '../../utils/classNames';

const cardClasses = 'bg-surface border border-border rounded-2xl p-6 shadow-sm';

const headerClasses = 'flex items-start justify-between gap-3 mb-4';

const stepClasses = 'text-[0.6875rem] font-bold uppercase tracking-[0.14em] text-subtle block mb-1';

const titleClasses = 'text-xl font-bold leading-tight text-content m-0 font-secondary';

const PreviewSectionCard = ({ step, title, badge, action, className, children }) => (
    <section className={cn(cardClasses, className)}>
        {(title || badge || action) && (
            <div className={headerClasses}>
                <div className="min-w-0">
                    {step && <span className={stepClasses}>{step}</span>}
                    {title && <h3 className={titleClasses}>{title}</h3>}
                </div>
                {(badge || action) && (
                    <div className="shrink-0 flex items-center gap-3">
                        {badge}
                        {action}
                    </div>
                )}
            </div>
        )}
        {children}
    </section>
);

export default PreviewSectionCard;
